import {getCurrentGroups} from "./lookWizardFunctions";

export const shouldSkipLock = ({wizardGroup = null,
                                 wizardActiveItem,
                                 wizardActiveStep,
                                 wizardSelectedValues}) => {
  if (wizardGroup) {
    return wizardGroup.skipLockDontApply
  }
  if (wizardActiveItem) {
    const currentGroups = getCurrentGroups(wizardActiveItem, wizardActiveStep, wizardSelectedValues);
    return currentGroups.length === 1 && currentGroups[0].nodeType === "group" && currentGroups[0].skipLockDontApply
  }
  return false;
}
